import { keepPreviousData, useQuery } from "@tanstack/react-query";

import peopleService from "@services/people.service";
import { QUERY_CACHE_DEFAULT_EXPIRATION_MS, SEARCHED_PEOPLE_QUERY_KEY } from "@config/query";

export function useSearchPeople(query: string) {
  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    queryKey: [SEARCHED_PEOPLE_QUERY_KEY, query],
    queryFn: async () => {
      return await peopleService.searchPeople(new URLSearchParams({ search: query }));
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
